import { withPreviewScope } from "@innoclouds/db";

const CHANNEL_NAME = withPreviewScope("org-updates");
const BUS_KEY = "__innocloudsOrgUpdatesBus__";

class OrgUpdateEvent extends Event {
	constructor(readonly payload: unknown) {
		super("message");
	}
}

const tryCreateBroadcastChannel = (name: string): BroadcastChannel | null => {
	try {
		if (typeof BroadcastChannel !== "function") return null;
		return new BroadcastChannel(name);
	} catch {
		return null;
	}
};

const getLocalBus = () => {
	const g = globalThis as typeof globalThis & { [BUS_KEY]?: EventTarget };
	if (!g[BUS_KEY]) g[BUS_KEY] = new EventTarget();
	return g[BUS_KEY];
};

let senderChannel: BroadcastChannel | null | undefined;

const getSenderChannel = () => {
	if (senderChannel !== undefined) return senderChannel;
	senderChannel = tryCreateBroadcastChannel(CHANNEL_NAME);
	return senderChannel;
};

export const sendMessage = (type: string, params: Record<string, unknown> = {}) => {
	const payload = { type, ...params };
	const channel = getSenderChannel();
	if (channel) {
		channel.postMessage(payload);
		return;
	}

	getLocalBus().dispatchEvent(new OrgUpdateEvent(payload));
};

export const subscribeOrgUpdates = (handler: (data: unknown) => void) => {
	const channel = tryCreateBroadcastChannel(CHANNEL_NAME);
	if (channel) {
		const onMessage = (event: MessageEvent) => handler(event.data);
		channel.addEventListener("message", onMessage);
		let closed = false;
		return () => {
			if (closed) return;
			closed = true;
			channel.removeEventListener("message", onMessage);
			channel.close();
		};
	}

	const bus = getLocalBus();
	const onMessage = (event: Event) => handler((event as OrgUpdateEvent).payload);
	bus.addEventListener("message", onMessage);
	let closed = false;
	return () => {
		if (closed) return;
		closed = true;
		bus.removeEventListener("message", onMessage);
	};
};
